import { useEffect, useState } from 'react';

import {
  getCurrentTokenWithoutRedirect,
  getOxygenId,
} from '@adsk/acs-sc-web-platform-api';

export const useOxygenId = () => {
  const [oxygenId, setOxygenId] = useState<string>();
  const [error, setError] = useState<Error>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function extractToken() {
      setLoading(true);

      try {
        const token = await getCurrentTokenWithoutRedirect();
        setOxygenId(getOxygenId(token.accessToken));
      } catch (currentError) {
        setError(currentError as Error);
      } finally {
        setLoading(false);
      }
    }

    void extractToken();
  }, []);

  return { oxygenId, error, loading };
};
